'use strict';
import noPoster from './components/no-poster';
import socialMedia from './components/social-media';

module.exports = function () {
    noPoster();
    socialMedia();
};
